import { KnownAction } from "../actions/reports.actions";
import { IReportsState, ReportItem } from "../models/reports.interface";

import { toDictionary } from "../../common/helpers/dictionary";

const initialState: IReportsState = {
};

function reportsReducer(
  state = initialState,
  action: KnownAction
): IReportsState {
  switch (action.type) {
    case "SET_REPORTS_ACTION": {
      const arr = action.data.map<ReportItem>(x => ({
        ...x,
        alias: (x.name ?? "").replace(/\W+/g, "-").toLowerCase()
      }));
      const dict = toDictionary(arr, x => x.alias, x => x);
      return {
        ...state,
        reports: arr,
        reportsByAlias: dict,
      };
    }
    default:
      return state;
  }
}

export default reportsReducer;
